import { render, staticRenderFns } from "./PayrollRunStatus.vue?vue&type=template&id=72c52790"
import script from "./PayrollRunStatus.vue?vue&type=script&lang=js"
export * from "./PayrollRunStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports